const FREESHIPPING_SNACKBAR_DURATION = {
  SHORT: 'SHORT',
  NORMAL: 'NORMAL',
  LONG: 'LONG',
  INFINITE: 'INFINITE',
};

export { FREESHIPPING_SNACKBAR_DURATION };
